/**
 * Wrapper for localStorage that made storage key uniq for any base path.
 * It's required for multiple projects on the same domain but at different folders
 */
import {BASE_URL} from "modules/constants";

export abstract class MLBStorage {
	/**
	 * Store key/value data in localStorage
	 */
	public static SET(key: string, value: unknown): void {
		const val = typeof value === "string" ? value : JSON.stringify(value || "");
		localStorage.setItem(MLBStorage.generate_key(key), val);
	}

	/**
	 * Get value by key from localStorage
	 */
	public static GET(key: string) {
		return localStorage.getItem(MLBStorage.generate_key(key));
	}

	/**
	 * Remove value by key from localStorage
	 */
	public static REMOVE(key: string): void {
		localStorage.removeItem(MLBStorage.generate_key(key));
	}

	/**
	 * Remove all values from localStorage
	 */
	public static FLUSH(): void {
		localStorage.clear();
	}

	private static generate_key(key: string): string {
		return `${BASE_URL}${key}`;
	}
}

export default Storage;
